/* eslint-disable no-lonely-if */
import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const generateUniverseFundsUrl = ({
  selectedClient,
  selectedFiduciary,
  currentPage,
  queryOptions,
  selectedProduct,
}) => {
  let url = '';

  if (selectedClient === 0) {
    /* eslint-disable-next-line max-len */
    url = `/fiduciaries/${selectedFiduciary}/funds?page=${currentPage}${queryOptions}`;
  } else if (selectedProduct === 0) {
    /* eslint-disable-next-line max-len */
    url = `/fiduciaryclients/${selectedClient}/funds?page=${currentPage}${queryOptions}`;
  } else {
    /* eslint-disable-next-line max-len */
    url = `/fiduciaryclients/${selectedClient}/product/${selectedProduct}/funds?page=${currentPage}${queryOptions}`;
  }

  return url;
};

export const getUniverseFundsList = async ({
  selectedClient,
  selectedFiduciary,
  currentPage,
  queryOptions,
  selectedProduct,
  axiosCancelToken,
}) => {
  const url = generateUniverseFundsUrl({
    selectedClient,
    selectedFiduciary,
    currentPage,
    queryOptions,
    selectedProduct,
  });
  return request.get(url, {}, axiosCancelToken);
};

export const getTagPreferredFundsUrl = ({
  selectedFiduciary,
  selectedClient,
  selectedProduct,
  isTargetSeries,
  secID,
}) => {
  let preferredUrl = '';
  if (selectedProduct) {
    /* eslint-disable-next-line max-len */
    preferredUrl = `/fiduciary-clients/${selectedClient}/products/${selectedProduct}/preferred`;
  } else if (isTargetSeries || selectedClient !== 0) {
    preferredUrl = `/fiduciary-clients/${selectedClient}/funds/preferred`;
  } else if (selectedClient === 0) {
    /* eslint-disable-next-line max-len */
    preferredUrl = `/fiduciaries/${selectedFiduciary}/funds/${secID}/preferred`;
  }

  return preferredUrl;
};

export const tagPreferredFunds = async ({
  selectedFiduciary,
  selectedClient,
  currentPage,
  queryOptions,
  selectedProduct,
  isTargetSeries,
  secID,
  payload,
  toTheActualAPI = true,
}) => {
  const url = getTagPreferredFundsUrl({
    selectedClient,
    selectedFiduciary,
    currentPage,
    queryOptions,
    selectedProduct,
    isTargetSeries,
    secID,
    toTheActualAPI,
  });
  return request.post(url, payload);
};

export const getNewAllClientViewFlag = async () => {
  const url = '/feature-flag/new-all-client-view-visibility';
  return request.get(url);
};

export const getAllClientChangeStatusViewFlag = async () => {
  const url = '/feature-flag/all-client-change-status-visibility';
  return request.get(url);
};

export const getAllClientUniverseFundsList = async ({
  selectedFiduciary,
  currentPage,
  queryOptions,
  axiosCancelToken,
}) => {
  const url = `/universe-funds/fc-all-client-view?pageNo=${currentPage}&fiduciaryId=${selectedFiduciary}${queryOptions}`;
  return request.get(url, {}, axiosCancelToken);
};

export const getAllClientStatusDetails = async (queryParams) => {
  const url = `/universe-funds/fc-all-client-view-hover?${queryParams}`;
  return request.get(url);
};

export const getReviewStatusAcrossClients = async (queryParams) => {
  const url = `/universe-funds/fundst-reviewst-allsharecl-allclients?${queryParams}`;
  return request.get(url);
};
